var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"lazy-container",rawName:"v-lazy-container",value:({ selector: 'img' }),expression:"{ selector: 'img' }"}],staticClass:"section-image"},[_c('div',{class:{
    'section-image__wrapper': true,
    'section-image__wrapper--open': _vm.showDescription,
    }},[_c('img',{attrs:{"data-src":_vm.img.src,"data-loading":_vm.img.preSrc,"alt":_vm.alt},on:{"click":_vm.toggleDesc,"mouseover":_vm.willChange,"mouseleave":_vm.removeWillChange}}),_c('p',{class:{
      'section-image__over-caption': true,
      'section-image__over-caption--open': _vm.showDescription,
      },domProps:{"innerHTML":_vm._s(_vm.caption)}})]),_c('p',{class:{
    'section-image__caption': true,
    'section-image__caption--close': !_vm.showDescription,
    },domProps:{"innerHTML":_vm._s(_vm.caption)}}),_c('p',{ref:"desc",class:{
    'section-image__description': true,
    'section-image__description--open': _vm.showDescription,
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }